var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M1.94 1h12.12c.506 0 .94.424.94.948a.942.942 0 0 1-.94.948H1.94A.953.953 0 0 1 1 1.948C1 1.421 1.421 1 1.94 1zm.017 3h9.086c.54 0 .957.424.957.948a.95.95 0 0 1-.957.948H1.957A.946.946 0 0 1 1 4.948.95.95 0 0 1 1.957 4zm-.008 3.104h6.102c.519 0 .949.424.949.948A.946.946 0 0 1 8.05 9h-6.1A.952.952 0 0 1 1 8.052c0-.528.425-.948.95-.948zM1.951 10h4.098a.947.947 0 1 1 0 1.896H1.951a.947.947 0 1 1 0-1.896zm-.003 3.104h2.104a.95.95 0 0 1 .948.948.946.946 0 0 1-.948.948H1.948A.95.95 0 0 1 1 14.052c0-.527.424-.948.948-.948zM14 12h1a.5.5 0 0 1 .416.777l-1.341 1.906c-.317.45-.832.451-1.15 0l-1.341-1.906A.5.5 0 0 1 12 12h1V8.5c0-.275.225-.5.5-.5s.5.225.5.5V12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.3335f8441f477832ab148e29b489210f.svg";
export { ForwardRef as ReactComponent };